import { GetterTree } from 'vuex';
import isEqual from 'lodash/isEqual';
import { RootState, EditableStatus, ListStatus } from '@/store/types';
import { DistributorsState } from '@/store/modules/distributors/types';

export const moduleGetters: GetterTree<DistributorsState, RootState> = {
  listIsLoading: (state) => state.listStatus === ListStatus.Loading,
  listIsLoaded: (state) => state.listStatus === ListStatus.Loaded,
  listIsError: (state) => state.listStatus === ListStatus.Failed,
  listIsEmpty: (state, getters) => getters.listIsLoaded && !state.list.length,
  editableIsLoading: (state) => state.editableStatus === EditableStatus.Loading,
  editableIsLoaded: (state) => state.editableStatus === EditableStatus.Loaded,
  editableIsSaving: (state) => state.editableStatus === EditableStatus.Saving,
  editableIsSaved: (state) => state.editableStatus === EditableStatus.Saved,
  editableIsError: (state) => state.editableStatus === EditableStatus.Failed,
  editableIsReady: (state, getters) => getters.editableIsLoaded || getters.editableIsSaved,
  editableHasUnsavedChanges: (state) => {
    const a = state.editableDistributor;
    const b = state.currentDistributor;
    if (!a || !b || !a.toJSON || !b.toJSON) {
      return false;
    }
    return !isEqual(a.toJSON(), b.toJSON());
  },
};

export default moduleGetters;
